import { HIDE_ALERT, SHOW_ALERT } from 'new/stores/showAlert/action';

const initialState = {
  type: '',
  error: null,
};

const alertReducer = (
  state = initialState,
  action: {
    type: string;
    error: any;
  },
) => {
  switch (action.type) {
    case HIDE_ALERT:
      return {
        ...state,
        ...action,
      };

    case SHOW_ALERT: {
      return {
        ...state,
        ...action,
      };
    }

    default:
      return state;
  }
};

export default alertReducer;
